export default __webpack_public_path__ + "static/media/app_overview_3.94c58f60.svg";